
import { ChartService, IYearOverviewPerMonthResult } from "@/services/chart-service";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardYearOverviewPerMonthData } from "@/utils/dashboard/dashboard-year-overview-per-month-data";
import { printHumanFloatDashboard } from "@/utils/pretty-print";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardYearOverviewPerMonthData(),
			result: [] as IYearOverviewPerMonthResult[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
	},
	computed: {
		totalRow():IYearOverviewPerMonthResult{
			let result:IYearOverviewPerMonthResult = {cost: 0, income: 0, difference: 0};
			for (let item of this.result) {
				result.cost += item.cost;
				result.income += item.income;
			}
			result.difference = result.income - result.cost;
			return result;
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data){
					this.data = new DashboardYearOverviewPerMonthData();
					return;
				}
				this.data = new DashboardYearOverviewPerMonthData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
		async fetch(){
			this.result = await ChartService.getYearOverviewPerMonth(this.data.incomeFilters, this.data.costFilters, this.data.getBookYearOverrideValue());
		},
		printNum(num:number):string{
			return printHumanFloatDashboard(num);
		}
	},
	created(){
		this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
